import { TemplatePortal } from '@angular/cdk/portal';
import { createAction, props } from '@ngrx/store';

export const setActionBarPortal = createAction(
  '[Action Bar Portal] Set Portal',
  props<{ portal: TemplatePortal<unknown> | null; forceLayoutClass: boolean }>(),
);

export const forceActionBarLayoutClass = createAction('[Action Bar Portal] Force Layout Class');

export const clearActionBarPortal = createAction('[Action Bar Portal] Clear Portal');
